import { DataTable } from "simple-datatables";
import $ from "jquery";
import htmx from 'htmx.org'

// we only use this file to make the imported classes available to the many small js
// files which expect them to live in the global window object.
window.DataTable = DataTable;
window.$ = $;
window.htmx = htmx;

window.onload = function () {
  document.body.addEventListener('htmx:responseError', function (evt) {
    alert(evt.detail.error);
  });
}
